import { createContext, useContext } from 'react';

export interface SplitViewState {
  /** The column stands in a dialog over the page: maximized, or no room for it beside the card. */
  inDialog: boolean;
  /** Whether the user's choice decides; on a narrow layout the column is a dialog anyway. */
  canMaximize: boolean;
  maximized: boolean;
  onMaximizedChange?: (maximized: boolean) => void;
  /** Beside the content as a panel filling the container, not a card (`SplitViewLayout`). */
  flush?: boolean;
}

/** What the column needs of the layout around it (`SplitViewLayout`). */
export const SplitViewContext = createContext<SplitViewState>({
  inDialog: false,
  canMaximize: false,
  maximized: false
});

export const useSplitView = () => useContext(SplitViewContext);
